/**
 * Mulberry32 seeded pseudo-random number generator
 * Returns a function that generates numbers between 0 and 1
 */
function mulberry32(seed) {
  return function () {
    let t = (seed += 0x6D2B79F5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Deterministic shuffle using Fisher–Yates
 * Does NOT mutate the original array
 */
export function shuffleWithSeed(array, seed) {
  const result = [...array]; // copy to avoid mutation
  const random = mulberry32(seed);

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}